import React from 'react';
import ReactDOM from 'react-dom/client';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import './assets/css/landing.css';

import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from 'react-query';

import AppRoutes from './routes/web';
import reportWebVitals from './reportWebVitals';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: 1,
			retryDelay: 1000,
		},
	},
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<QueryClientProvider client={queryClient}>
		<AppRoutes />

		<ToastContainer
			position="top-right"
			autoClose={3000}
			theme="light"
		/>
	</QueryClientProvider>
);

reportWebVitals();